import React, { useContext } from 'react';
import { ATCprops, AddToCart } from '.';
import { ProductContext } from '../../ProductContext';
import { useMediaQuery } from '@material-ui/core';
import { MUI_DESKTOP_BREAKPOINT } from 'src/scripts/utils/constants';
import { useIntersectionObserver } from 'src/scripts/templates/_shared/react-hooks';
import { isStickyNavbar } from '../../utils';

const OmniPdpStickyATCButtonBlock = ({
  atcProps,
  mainATCbutton,
}: {
  atcProps: ATCprops;
  mainATCbutton: React.RefObject<HTMLDivElement>;
}) => {
  const isDesktop = useMediaQuery(MUI_DESKTOP_BREAKPOINT, { noSsr: true });
  const { similarItemsCarouselExists } = useContext(ProductContext);

  // to calculate the rootMargin on initial render;
  const mainHeader = document.querySelector('#shopify-section-header');
  const mainHeaderRect = mainHeader?.getBoundingClientRect();
  const universalBanner = document.querySelector('.sticky-uni-banner');
  const universalBannerRect = universalBanner?.getBoundingClientRect();
  const navHeight = mainHeaderRect ? mainHeaderRect.height : 0;
  const universalBannerHeight = universalBannerRect ? universalBannerRect.height : 0;
  const stickyAtcTop = isStickyNavbar() ? universalBannerHeight + navHeight : universalBannerHeight;

  // checking ATC button visibility on screen to show/hide the sticky ATC button block on mobile
  const { isIntersecting: onScreen } = useIntersectionObserver(mainATCbutton, {
    rootMargin: `-${stickyAtcTop + 10}px 0px -50px 0px`,
  });

  if (isDesktop) return null;

  return (
    <div className={`omni-pdp-sticky-atc-block ${onScreen ? 'hide' : 'show'}`}>
      <AddToCart
        {...atcProps}
        testId="add-to-cart-buy-button-sticky-mobile"
        similarItemsCarouselExists={similarItemsCarouselExists}
        ATBtype="Sticky"
      />
    </div>
  );
};

export default OmniPdpStickyATCButtonBlock;
